<template>
  <article
    class="product-teaser product-teaser--big"
    :class="productclass"
  >
    <a
      class="product-teaser__link product-teaser--big__link"
      :href="product.link"
    >
      <div class="product-teaser--big__container grid-wrap no-gutter">
        <div class="product-teaser--big__right grid-col grid-col-right bp2-col-one-third bp3-col-one-half">
          <sale-flash
            v-if="product.show_price"
            :product="product"
            :sale-type="'big-teaser'"
          />
          <div
            v-if="product.image.product"
            class="product-teaser-big__image-container"
          >
            <img
              v-lazy="product.image.product"
              class="product-teaser-big__image"
              alt=""
            >
            <span
              v-if="product.brand.modeo_plus && !product.sale"
              class="modeo-plus"
              aria-label="Modeo+"
            >+</span>
            <product-sticker
              :id="product.sticker"
              :class-name="['product-sticker', 'product-sticker--big']"
            />
          </div>
        </div>
        <div class="product-teaser--big__left grid-col bp2-col-two-thirds bp3-col-one-half">
          <h3 class="product-teaser-big__heading">
            <span
              v-if="product.brand.modeo_plus"
              class="modeo-plus"
            >{{ product.brand.modeo_plus.name }}</span>
            <!-- eslint-disable vue/no-v-html -->
            <span
              v-if="product.brand && product.brand.name"
              class="product-teaser-big__brand"
              v-html="$sanitize(product.brand.name)"
            />
            <!-- eslint-enable vue/no-v-html -->
            {{ product.name }}
          </h3>
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="product.text"
            class="product-teaser-big__text"
            v-html="$sanitize(product.text)"
          />
          <!-- eslint-enable vue/no-v-html -->
          <div
            class="price price--big"
            :class="{'price--big--no-price' : !product.show_price}"
          >
            <div class="product-teaser--big__price-amount-container price-amount-container price-amount-container--big">
              <template v-if="product.price_from_with_add_ons && product.show_price">
                <span
                  v-if="product.variations_has_different_prices"
                  class="starting-from"
                >alk.</span>
                <span
                  class="product-teaser__price-amount price-amount"
                  :class="{ 'price-amount--ins': product.price_from_with_add_ons != product.regular_price_from_with_add_ons }"
                >
                  <price
                    :price-without-tax="product.prices_without_tax.price_from_with_add_ons"
                    :price-with-tax="product.prices_with_tax.price_from_with_add_ons"
                  />
                </span>
                <span
                  v-if="product.price_from_with_add_ons != product.regular_price_from_with_add_ons"
                  class="product-teaser__price-amount price-amount price-amount--del"
                >
                  <price
                    :price-without-tax="product.prices_without_tax.regular_price_from_with_add_ons"
                    :price-with-tax="product.prices_with_tax.regular_price_from_with_add_ons"
                  />
                </span>
              </template>
            </div>
            <div
              class="price-details price-details--big"
              :class="{'price-details--no-price' : !product.show_price}"
            >
              <span
                v-if="product.show_price"
                class="tax tax--big"
                :class="{ 'tax--highlight tax--highlight-big': (product.outlet && !$store.getters.showPricesWithVat) }"
              >{{ $modeoL10n.vat }} {{ $store.getters.displayVat }}</span>
              <button class="btn btn--buy">{{ product.show_price && !product.disable_buying ? $modeoL10n.buy : $modeoL10n.check_out }}</button>
            </div>
          </div>
        </div>
      </div>
    </a>
  </article>
</template>

<script>
import SaleFlash from './sale-flash.vue';
import ProductSticker from './product-sticker.vue';

export default {
    components: {
        SaleFlash,
        ProductSticker,
    },
    props: {
        product: {
            type: Object,
            default: function () {
                return {};
            },
        },
        productclass: {
            type: String,
            default: '',
        },
    },
}
</script>
